import { z } from 'zod';
/**
 * Payment (FR-PAY-01…08, NFR-06). ONE component serves subscriptions,
 * donations, tickets and promotions (ADR-06). ONOV never stores PAN/CVV —
 * only gateway tokens (FR-PAY-08). Amounts are integer minor units.
 */
export const Currency = z.enum(['USD']);
export const PurchaseKind = z.enum(['subscription', 'donation', 'ticket', 'promotion']);
export const PaymentMethodKind = z.enum(['card', 'apple_pay']);
/** Saved card as displayed: brand + last4, never more (docs/03 §15.2). */
export const PaymentMethodView = z.object({
    id: z.string(),
    kind: PaymentMethodKind,
    brand: z.string().nullable(),
    last4: z.string().length(4).nullable(),
    expMonth: z.number().int().min(1).max(12).nullable(),
    expYear: z.number().int().nullable(),
    isDefault: z.boolean(),
    createdAt: z.coerce.date(),
});
/** Client attaches a GATEWAY token — raw card data never reaches ONOV. */
export const AttachPaymentMethodInput = z.object({
    gatewayToken: z.string().min(8),
    kind: PaymentMethodKind.default('card'),
    makeDefault: z.boolean().default(false),
});
export const PaymentSummary = z.object({
    subtotalMinor: z.number().int().nonnegative(),
    taxMinor: z.number().int().nonnegative(),
    totalMinor: z.number().int().nonnegative(),
    currency: Currency,
});
export const PaymentStatus = z.enum([
    'pending',
    'succeeded',
    'failed',
    'refunded',
    'partially_refunded',
]);
export const PaymentView = z.object({
    id: z.string(),
    kind: PurchaseKind,
    /** The thing paid for — subscription id, content id (fundraiser), event id, promotion id. */
    referenceId: z.string(),
    summary: PaymentSummary,
    status: PaymentStatus,
    failureReason: z.string().nullable(),
    refundedMinor: z.number().int().nonnegative(),
    createdAt: z.coerce.date(),
});
/** Payout account for fundraising receipts (FR-FUND-03, FR-PAY-06) — tokenised. */
export const PayoutKind = z.enum(['bank', 'paypal']);
export const AttachPayoutInput = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('bank'),
        gatewayToken: z.string().min(8),
        last4: z.string().length(4),
        holderName: z.string().min(1).max(120),
    }),
    z.object({ kind: z.literal('paypal'), email: z.string().email() }),
]);
export const PayoutView = z.object({
    id: z.string(),
    kind: PayoutKind,
    /** bank: last4; paypal: masked email. */
    display: z.string(),
    createdAt: z.coerce.date(),
});
//# sourceMappingURL=payment.js.map